/**
 * Currency types and utilities
 *
 * NOTE: CurrencyInfo interface should match the schema from api-gateways/openapi/buyer.yml
 * After regenerating buyerApiClient, import CurrencyInfo from there instead.
 */

import flagBRL from '@src/assets/flags/flag-brl.svg';
import flagUSD from '@src/assets/flags/flag-usd.svg';
import flagEUR from '@src/assets/flags/flag-eur.svg';
import flagARS from '@src/assets/flags/flag-ars.svg';
import flagUYU from '@src/assets/flags/flag-uyu.svg';
import flagGBP from '@src/assets/flags/flag-gbp.svg';
import flagMXN from '@src/assets/flags/flag-mxn.svg';

export type { CurrencyInfo } from '@src/core/buyerApiClient/api';

/** Default currency used for transactions */
export const DEFAULT_CURRENCY = 'BRL';

/** Supported currencies with their display info */
export const SUPPORTED_CURRENCIES = [
  { code: 'BRL', label: 'Real', shortLabel: 'Real', symbol: 'R$', locale: 'pt-BR', flagSrc: flagBRL },
  { code: 'USD', label: 'Dólar', shortLabel: 'Dólar', symbol: '$', locale: 'en-US', flagSrc: flagUSD },
  { code: 'EUR', label: 'Euro', shortLabel: 'Euro', symbol: '€', locale: 'de-DE', flagSrc: flagEUR },
  { code: 'ARS', label: 'Peso Argentino', shortLabel: 'Peso', symbol: '$', locale: 'es-AR', flagSrc: flagARS },
  { code: 'UYU', label: 'Peso Uruguaio', shortLabel: 'Peso', symbol: '$U', locale: 'es-UY', flagSrc: flagUYU },
  { code: 'GBP', label: 'Libra', shortLabel: 'Libra', symbol: '£', locale: 'en-GB', flagSrc: flagGBP },
  { code: 'MXN', label: 'Peso Mexicano', shortLabel: 'Peso', symbol: '$', locale: 'es-MX', flagSrc: flagMXN },
] as const;

export type SupportedCurrencyCode = (typeof SUPPORTED_CURRENCIES)[number]['code'];

/** Default available currencies for currency selector */
export const DEFAULT_AVAILABLE_CURRENCIES: SupportedCurrencyCode[] = ['BRL', 'UYU'];

/**
 * Get currency info by code
 */
export const getCurrencyInfo = (code: string) => {
  return SUPPORTED_CURRENCIES.find((c) => c.code === code) || SUPPORTED_CURRENCIES[0];
};
